import { message } from "antd";
import React, { Component } from 'react';
import PubSub from 'pubsub-js'
import { AesKey, Design_Upload_Map, deviceNo, SPIN_DIALOG_HIDE, SPIN_DIALOG_SHOW, Upload_Building, Upload_Data, Upload_Mesh } from "../../const/infoConst";
import { getRandomStr } from "../dataUtils";
import { get_groupList, get_jsonData } from "../profileUtils";
import { decryptByAes256CBC, encryptByAes256CBC } from "../secret/aesCBC";
import { meshLog, SPGet, SPRemove, SPSet } from "../spUtils";
import { createOrUpdateBuilding, createOrUpdateMesh, deleteBuilding, deleteMesh, deleteShareBuildingMesh, getBuilding, getMesh, getQRReceiverList, uploadFileNetworking } from "./netManager";
import axios from "axios";
import { exportTimeFormatter } from "../timeUtils";
import { getGroupImgName } from "../fileUtils";
import { saveDeviceInfor } from "../profileUtils";
import { getSelectBuildingUUID, setDesignDeviceArr, setDesignGroupArr } from "../meshUtils";

//---------------------------------------------------------------Building--------------------------------------------------------------
//获取Building列表
export const loadBuildDataAndUpdateUI = async () => {
    //先获取building，找到isSelected为1的，拿到uuid。然后在访问mesh接口，找到加密的json，解密 SPSet("token", value.token)   SPRemove("token")
    let token = SPGet('token')
    let maddr = SPGet('email')
    let result = await getBuilding(maddr, deviceNo, token);
    //如果build长度0，没有isSelected为1 home界面显示空
    if (result.code == 0) {
        const buildingList = result.msg.buildingList
        meshLog('所有的building', buildingList);
        if (buildingList.length == 0) {
            SPSet("buildingListLength", 0)
        } else {
            let isSelected = buildingList.find(item => item.isSelected == 1)

            if (!isSelected) {
                isSelected = buildingList[0]; //没有选中，取第一个
                isSelected.isSelected = 1;
            }
            if (isSelected) {
                const buildingUUID = isSelected.buildingUUID
                let buildingresult = await getMesh(maddr, deviceNo, token, buildingUUID);
                getSelectBuildingInfo(buildingresult, "");
                SPSet("SelectBuildingName", isSelected.buildingName)
                SPSet("buildingList", JSON.stringify(buildingList))
                SPRemove("buildingListLength")
                SPSet("buildingListLength", buildingList.length)
            } else {
                SPSet("buildingListLength", 0)
            }
        }
    }
}


//获取单个Building信息
export const changeSelectBuilding = async (buildingName, meshName) => {
    PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
    let token = SPGet('token')
    let maddr = SPGet('email')
    meshLog('获取单个Building信息', buildingName, meshName);
    let buildingList = JSON.parse(SPGet("buildingList"));
    let isSelected = buildingList.find(item => item.buildingName == buildingName)
    if (isSelected) {
        // meshLog('isSelected', isSelected);
        const buildingUUID = isSelected.buildingUUID
        let buildingresult = await getMesh(maddr, deviceNo, token, buildingUUID);
        getSelectBuildingInfo(buildingresult, meshName);

        SPSet("SelectBuildingName", buildingName)
        SPSet("buildingList", JSON.stringify(buildingList))
        SPRemove("buildingListLength")
        SPSet("buildingListLength", buildingList.length)
    } else {
        SPSet("buildingListLength", 0)
    }
}

//获取选中Building中的Mesh列表信息
export const getSelectBuildingInfo = (buildingresult, meshName) => {
    meshLog('选中的Building', buildingresult);
    meshLog('选中的Mesh', meshName);
    const meshList = buildingresult.msg.meshList
    SPSet("meshList", JSON.stringify(meshList))
    //mesh对应的area，要先判断这个mesh下有没有数据
    if (meshList.length == 0) {
        // meshLog('meshList', meshList.length);
    } else {
        //如果有，默认解密meshlist中第一个数据的poidfile
        if (meshName == "") {
            for (let index = 0; index < meshList.length; index++) {
                meshLog('meshList[index].profile', meshList[index].profile !== '');
                if (meshList[index].profile !== '') {
                    getMeshInfoFromBuilding(meshList[index])//解密过程
                    break
                }

            }

        } else {
            changeSelectMesh(meshName);
        }

        //获取OTA固件版本
        const otaurl = 'https://iot.hsesmartinc.com/light/version.json'
        axios.get(otaurl)
            .then(async (value) => {
                meshLog('value', value.data);
                const firmware_version = value.data.version
                console.log('firmware_version:', firmware_version);
                SPSet("firmware_version", JSON.stringify(firmware_version))

            })
            .catch((resaon) => {
                meshLog(resaon);
            })
    }
}

//创建新Building
export const createNewBuilding = async (name, company, city, address) => {
    PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
    let maddr = SPGet('email');
    let token = SPGet('token');
    let uuid = getRandomStr(32);
    let introduction = "web";
    let isSelected = 1;
    //maddr, token, deviceNo, buildingUUID, buildingName, companyName, city, address, introduction, isSelected
    //createTime, version, role
    meshLog('wjk create Building', maddr, token, deviceNo, uuid, name, company, city, address, introduction, isSelected);
    let result = await createOrUpdateBuilding(maddr, token, deviceNo, uuid, name, company, city, address, introduction, isSelected);
    meshLog('result', result);
    //{code: 0, msg: {createTime: "2025-11-04 09:58:22"}}
    const { code, msg } = result;
    if (code === 0) {
        let createTime = exportTimeFormatter();
        let version = 1;
        let role = 0;
        createNewMesh(uuid, "Area", Upload_Building);

    } else {
        message.warning({ content: 'Network error, please check', style: { fontSize: "25px" } });
        PubSub.publish(SPIN_DIALOG_HIDE, '');
    }
}

//切换或更新Building
export const selectOrUpdateBuilding = async (uuid, name, company, city, address, isSelected) => {
    PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
    let maddr = SPGet('email');
    let token = SPGet('token');
    let introduction = "web";
    meshLog('wjk 切换或更新 Building', maddr, token, deviceNo, uuid, name, company, city, address, introduction, isSelected);
    let result = await createOrUpdateBuilding(maddr, token, deviceNo, uuid, name, company, city, address, introduction, isSelected);
    const { code, msg } = result;
    meshLog('result', result);  //{code: 0, msg: {createTime: "2026-01-16 03:58:38"}}
    if (code === 0) {
        meshLog('wjk 切换或更新成功');
        loadBuildDataAndUpdateUI();
    } else {
        message.warning({ content: 'Network error, please check', style: { fontSize: "25px" } });
        PubSub.publish(SPIN_DIALOG_HIDE, '');
    }
}

//删除Building
export const deleteCurBuilding = async (uuid) => {
    PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
    let maddr = SPGet('email');
    let token = SPGet('token');
    meshLog('wjk 删除Building', maddr, deviceNo, token, uuid);
    let result = await deleteBuilding(maddr, deviceNo, token, uuid);
    const { code, msg } = result;
    meshLog('result', result);  //{code: 0}
    if (code === 0) {
        meshLog('wjk 删除Building 成功');
        loadBuildDataAndUpdateUI();
    } else {
        message.warning({ content: 'Network error, please check', style: { fontSize: "25px" } });
        PubSub.publish(SPIN_DIALOG_HIDE, '');
    }
}

//---------------------------------------------------------------模拟计量--------------------------------------------------------------
export const judgeEnergyDataExist = () => {
    let build = SPGet("energy_SelectBuildingName");
    let mesh = SPGet("energy_SelectMeshName");
    let group = SPGet("energy_groupList");
    //若不存在数据，使用默认building、mesh数据
    if (!build || !mesh || !group) {
        meshLog("wjk 存储默认数据");
        SPSet("energy_SelectBuildingName", SPGet("SelectBuildingName"));
        SPSet("energy_meshList", SPGet("meshList"))
        SPSet("energy_SelectMeshName", SPGet("SelectMeshName"));
        SPSet("energy_jsonData", SPGet("jsonData"))
        SPSet("energy_groupList", SPGet("groupList"))
        SPSet("energy_nodes", SPGet("nodes"))
        SPSet("energy_meshUUID", SPGet("meshUUID"))
        SPSet("energy_jiliang", SPGet("jiliang"))
    }
}

//获取单个Building信息
export const changeEnergySelectBuilding = async (buildingName, meshName) => {
    PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
    let token = SPGet('token')
    let maddr = SPGet('email')
    meshLog('获取单个Building信息', buildingName, meshName);
    let buildingList = JSON.parse(SPGet("buildingList"));
    let isSelected = buildingList.find(item => item.buildingName == buildingName)
    if (isSelected) {
        // meshLog('isSelected', isSelected);
        const buildingUUID = isSelected.buildingUUID
        let buildingresult = await getMesh(maddr, deviceNo, token, buildingUUID);
        getEnergySelectBuildingInfo(buildingresult, meshName);

        SPSet("energy_SelectBuildingName", buildingName)
    }
}

//获取选中Building中的Mesh列表信息
export const getEnergySelectBuildingInfo = (buildingresult, meshName) => {
    meshLog('选中的Building', buildingresult);
    meshLog('选中的Mesh', meshName);
    const meshList = buildingresult.msg.meshList
    SPSet("energy_meshList", JSON.stringify(meshList))
    //mesh对应的area，要先判断这个mesh下有没有数据
    if (meshList.length == 0) {
        // meshLog('meshList', meshList.length);
    } else {
        //如果有，默认解密meshlist中第一个数据的poidfile
        if (meshName == "") {
            for (let index = 0; index < meshList.length; index++) {
                meshLog('meshList[index].profile', meshList[index].profile !== '');
                if (meshList[index].profile !== '') {
                    getEnergyMeshInfoFromBuilding(meshList[index])//解密过程
                    break
                }
            }
        } else {
            changeEnergySelectMesh(meshName);
        }
    }
}
//切换Mesh
export const changeEnergySelectMesh = async (name) => {
    SPSet("energy_SelectMeshName", name)
    const meshList = JSON.parse(SPGet("energy_meshList"))
    let ismeshlist = meshList.find(item => item.meshName == name)
    meshLog('ismeshlist', ismeshlist);
    getEnergyMeshInfoFromBuilding(ismeshlist);
}
export const getEnergyMeshInfoFromBuilding = (ismeshlist) => {
    PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
    //meshLog("修改参数:", areaItem);
    const dUrl = ismeshlist.profile
    axios.get(dUrl)
        .then(async (value) => {
            //meshLog('admin235value', value.data);
            const hex_key = ismeshlist.meshUUID + AesKey
            const decryptedString = decryptByAes256CBC(hex_key, value.data)
            const jsonData = JSON.parse(decryptedString);
            meshLog('energy_jsonData', jsonData);//拿到需要解析的所有数据
            const groupList = jsonData.groupList
            const nodes = jsonData.nodes
            let energy_jiliang = nodes.find(item => item.pid == '4181')
            if (energy_jiliang) {
                SPSet("energy_jiliang", JSON.stringify(energy_jiliang))
            } else {
                energy_jiliang = { 'macAddress': '1234567890' }
                SPSet("energy_jiliang", JSON.stringify(energy_jiliang))

            }
            SPSet("energy_SelectMeshName", ismeshlist.meshName);
            SPSet("energy_jsonData", JSON.stringify(jsonData))
            SPSet("energy_groupList", JSON.stringify(groupList))
            SPSet("energy_meshUUID", ismeshlist.meshUUID);

            for (let i = 0; i < nodes.length; i++) {
                nodes[i]["online"] = 1;
                nodes[i]["brightness"] = 0;
                nodes[i]["is_on"] = 1;
                nodes[i]["dev_type"] = 0;
            }
            SPSet("energy_nodes", JSON.stringify(nodes))

            PubSub.publish('changeEnergyMeshUpdateUI', '')//mesh更新，刷新数据
            PubSub.publish(SPIN_DIALOG_HIDE, '');
        })
        .catch((resaon) => {
            meshLog("json异常:", resaon);
            PubSub.publish(SPIN_DIALOG_HIDE, '');
        })
}

//获取到当前groupId下的所有的灯
export const getEnergyDevicesByGroupId = (groupId) => {
    meshLog('groupId', groupId);
    const nodes = JSON.parse(SPGet("energy_nodes"))
    meshLog('energy_nodes', nodes);
    let deviceSet = nodes.filter((item) => {
        //if (item.groupID == groupId && item.isProvisioned == true) {
        if (item.groupID == groupId) {
            return item
        }
    })
    return deviceSet
}

//---------------------------------------------------------------Mesh--------------------------------------------------------------


//获取Mesh profile数据
export const getMeshInfoFromBuilding = (ismeshlist) => {
    PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
    //meshLog("修改参数:", areaItem);
    const dUrl = ismeshlist.profile
    axios.get(dUrl)
        .then(async (value) => {
            //meshLog('admin235value', value.data);
            const hex_key = ismeshlist.meshUUID + AesKey
            const decryptedString = decryptByAes256CBC(hex_key, value.data)
            const jsonData = JSON.parse(decryptedString);
            meshLog('jsonData', jsonData);//拿到需要解析的所有数据
            const groupList = jsonData.groupList
            const nodes = jsonData.nodes
            const sceneList = jsonData.sceneList || []
            let wangguan = nodes.find(item => item.pid == '4100')
            let jiliang = nodes.find(item => item.pid == '4181')
            let miniwangguan = nodes.find(item => item.pid == '4274')
            //如果没有网关，这边需要做个判断 这边需要添加一个计量设备的判断，和网关的逻辑一样
            if (wangguan) {
                SPSet("wangguan", JSON.stringify(wangguan))
            } else {
                wangguan = { 'macAddress': '1234567890' }
                SPSet("wangguan", JSON.stringify(wangguan))
            }
            if (jiliang) {
                SPSet("jiliang", JSON.stringify(jiliang))
                // SPSet("energy_jiliang", JSON.stringify(jiliang))
            } else {
                jiliang = { 'macAddress': '1234567890' }
                SPSet("jiliang", JSON.stringify(jiliang))
                // SPSet("energy_jiliang", JSON.stringify(jiliang))
            }
            if (miniwangguan) {
                SPSet("jiliang", JSON.stringify(miniwangguan))
                SPSet("wangguan", JSON.stringify(miniwangguan))
            }
            meshLog('miniwangguan', miniwangguan);

            //切换mesh成功，存储mesh数据
            SPSet("mesh_version", ismeshlist.version); //版本号
            SPSet("SelectMeshName", ismeshlist.meshName);
            SPSet("meshUUID", ismeshlist.meshUUID); //版本号

            //在获取网关之后再链接mqtt
            PubSub.publish('mqttLink', wangguan)//隐藏加载框
            meshLog('mqttLink网关发送', wangguan);
            SPSet("jsonData", JSON.stringify(jsonData))
            SPSet("groupList", JSON.stringify(groupList))
            //新建一个方法新增一个字段，为单灯创建在不在线的问题  SPSet("nodes", JSON.stringify(nodes))
            saveDeviceInfor(nodes)
            SPSet("sceneList", JSON.stringify(sceneList))
            SPSet("mapImage", ismeshlist.image)
            setDesignGroupArr();
            setDesignDeviceArr();
            judgeEnergyDataExist();
            PubSub.publish('changeMeshUpdateUI', '')//mesh更新，刷新数据
            PubSub.publish('updateGroupdataUI', '')//刷新组的数据
            PubSub.publish(Design_Upload_Map, ismeshlist.image);//布点图
            PubSub.publish(SPIN_DIALOG_HIDE, '');

        })
        .catch((resaon) => {
            meshLog("json异常:", resaon);
            PubSub.publish(SPIN_DIALOG_HIDE, '');
        })
}

//切换Mesh
export const changeSelectMesh = async (name) => {
    SPSet("SelectMeshName", name)
    const meshList = JSON.parse(SPGet("meshList"))
    let ismeshlist = meshList.find(item => item.meshName == name)
    meshLog('ismeshlist', ismeshlist);
    getMeshInfoFromBuilding(ismeshlist);
}

//新建mesh
export const createNewMesh = async (buildingUUID, meshName, isUpdateBuild) => {
    PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
    let maddr = SPGet('email');
    let token = SPGet('token');
    let meshUUID = getRandomStr(32);
    meshLog('新建mesh', maddr, token, deviceNo, buildingUUID, meshUUID, meshName);
    let result = await createOrUpdateMesh(maddr, token, deviceNo, buildingUUID, meshUUID, meshName);
    meshLog('新建mesh', result);
    const { code, msg } = result;
    //{code: 0}
    if (code === 0) {
        let json = get_jsonData(maddr, meshName, meshUUID);
        const hex_key = meshUUID + AesKey;
        SPSet("mesh_version", 1); //版本号
        let info = encryptByAes256CBC(hex_key, JSON.stringify(json));
        SPSet("SelectMeshName", meshName)
        uploadFileNetworking(meshUUID, info, isUpdateBuild);
    } else {
        message.warning({ content: 'Network error, please check', style: { fontSize: "25px" } });
        PubSub.publish(SPIN_DIALOG_HIDE, '');
    }
}


//更新mesh(只能重命名)
export const updateCurMesh = async (buildingUUID, meshUUID, meshName) => {
    PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
    let maddr = SPGet('email');
    let token = SPGet('token');
    meshLog('更新mesh', maddr, token, deviceNo, buildingUUID, meshUUID, meshName);
    let result = await createOrUpdateMesh(maddr, token, deviceNo, buildingUUID, meshUUID, meshName);
    meshLog('更新mesh', result);
    const { code, msg } = result;
    //{code: 0}
    if (code === 0) {
        meshLog('wjk 更新mesh成功');
        let buildname = SPGet("SelectBuildingName");
        changeSelectBuilding(buildname, meshName);
    } else {
        message.warning({ content: 'Network error, please check', style: { fontSize: "25px" } });
        PubSub.publish(SPIN_DIALOG_HIDE, '');
    }
}

//删除mesh
export const deleteCurMesh = async (uuid, name) => {
    PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
    let maddr = SPGet('email');
    let token = SPGet('token');
    meshLog('wjk 删除mesh', maddr, deviceNo, token, uuid);
    let result = await deleteMesh(maddr, deviceNo, token, uuid);
    const { code, msg } = result;
    meshLog('result', result);
    if (code === 0) {
        meshLog('wjk 删除mesh成功');
        let buildname = SPGet("SelectBuildingName");
        if (name == SPGet("SelectMeshName")) {
            changeSelectBuilding(buildname, "");
        } else {
            changeSelectBuilding(buildname, SPGet("SelectMeshName"));
        }
    } else {
        message.warning({ content: 'Network error, please check', style: { fontSize: "25px" } });
        PubSub.publish(SPIN_DIALOG_HIDE, '');
    }
}




//---------------------------------------------------------------Group--------------------------------------------------------------
export const createNewGroup = async (name, mId) => {
    let groupID = getNewGroupID();
    let groupImgName = getGroupImgName(mId);
    let arr = get_groupList(groupID, name, groupImgName);

    meshLog('新建Group', groupID, name, groupImgName);

    let jsonData = JSON.parse(SPGet("jsonData"))
    //将组信息存入json
    let group = jsonData.groupList;
    group[group.length] = arr[0];
    jsonData.groupList = group;
    jsonData.meshName = SPGet("SelectMeshName");
    //上传profile
    const hex_key = jsonData.meshUUID + AesKey;
    let info = encryptByAes256CBC(hex_key, JSON.stringify(jsonData));
    uploadFileNetworking(jsonData.meshUUID, info, Upload_Mesh);

}

//获取新建组Id
function getNewGroupID() {
    let arr = JSON.parse(SPGet("groupList"))
    let addPos = 1;
    for (let k = 1; k <= 150; k++) {
        let isExist = false;
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].groupID == k) {
                isExist = true;
            }
        }
        if (!isExist) {
            addPos = k;
            break;
        }
    }
    return addPos
}



//---------------------------------------------------------------Schedule--------------------------------------------------------------
export const uploadNewScheduleData = async (schedule) => {
    let jsonData = JSON.parse(SPGet("jsonData"))
    //定时
    jsonData.sceneList = schedule;
    jsonData.meshName = SPGet("SelectMeshName");
    //上传profile
    const hex_key = jsonData.meshUUID + AesKey;
    let info = encryptByAes256CBC(hex_key, JSON.stringify(jsonData));
    meshLog('上传jsonData', jsonData);
    uploadFileNetworking(jsonData.meshUUID, info, Upload_Mesh);
}

//---------------------------------------------------------------json上传--------------------------------------------------------------
export const uploadCurJsonData = async () => {
    let jsonData = JSON.parse(SPGet("jsonData"))
    //定时
    jsonData.groupList = JSON.parse(SPGet("groupList"));
    jsonData.nodes = JSON.parse(SPGet("nodes"));
    jsonData.zoneList = [];

    //上传profile
    const hex_key = jsonData.meshUUID + AesKey;
    let info = encryptByAes256CBC(hex_key, JSON.stringify(jsonData));
    meshLog('上传jsonData', jsonData);
    uploadFileNetworking(jsonData.meshUUID, info, Upload_Data);

}

//布点图操作后，延迟10秒上传json数据
let timer;
export const startDelayedUploadAction = () => {
    meshLog('wjk json上传', timer);
    if (timer) {
        clearTimeout(timer);
        console.log('wjk Delayed action canceled!');
    }

    timer = setTimeout(() => {
        console.log('wjk Delayed action executed!');
        uploadCurJsonData();
    }, 10000); // 延迟3秒执行
};


//---------------------------------------------------------------分享--------------------------------------------------------------

//获取分享列表
export const getQRReceiverDataList = async () => {
    PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
    let maddr = SPGet('email');
    let token = SPGet('token');
    let buildingUUID = getSelectBuildingUUID(SPGet("SelectBuildingName"));
    let meshUUID = "";
    meshLog('wjk 获取分享列表');
    let result = await getQRReceiverList(maddr, deviceNo, token, buildingUUID, meshUUID);
    const { code, msg } = result;
    meshLog('result', result);  //{code: 0, msg: [{name: "TT", receiver: "kuohogvcln@xghff.com", role: 2}]}
    if (code === 0) {
        meshLog('wjk 获取分享列表成功');
        PubSub.publish(SPIN_DIALOG_HIDE, '');
        let list = [];
        if (msg.length > 0) {
            for (let i = 0; i < msg.length; i++) {
                list[i] = { "id": i, 'name': msg[i].name, 'receiver': msg[i].receiver, 'role': msg[i].role }
            }
        }
        return new Promise((resolve, reject) => {
            resolve(list); // 成功时返回数据
        });

    } else {
        message.warning({ content: 'Network error, please check', style: { fontSize: "25px" } });
        PubSub.publish(SPIN_DIALOG_HIDE, '');
    }
}

//获取分享账户列表
export const deleteShareBuildingData = async (receiver) => {
    PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
    let maddr = SPGet('email');
    let token = SPGet('token');
    let buildingUUID = getSelectBuildingUUID(SPGet("SelectBuildingName"));
    let meshUUID = "";
    meshLog('wjk 获取分享账户列表');
    let result = await deleteShareBuildingMesh(maddr, deviceNo, token, buildingUUID, meshUUID, receiver);
    const { code, msg } = result;
    meshLog('result', result);  //{code: 0}
    if (code === 0) {
        meshLog('wjk 获取分享账户列表成功');
        PubSub.publish(SPIN_DIALOG_HIDE, '');
        return new Promise((resolve, reject) => {
            resolve(); // 成功时返回数据
        });

    } else {
        message.warning({ content: 'Network error, please check', style: { fontSize: "25px" } });
        PubSub.publish(SPIN_DIALOG_HIDE, '');
    }
}
